import { Field } from 'react-final-form'

import { FormControl } from '../../components/FormControl'
import { TextProps } from '../../components/Text/Text'
import { FieldInterceptor } from '../../utils/validation'
import { TextArea, TextAreaProps } from '../../components/Text/TextArea'
import { ThemeWrapper } from '../../components/theme'

type Props = {
  label?: string
  placeholder?: string
  name: string
  labelProps?: TextProps
  additionalProps?: TextAreaProps
  hideValidationMessage?: boolean
  interceptor?: FieldInterceptor<any>
  format?: FieldInterceptor<any>
}

export const TextAreaField = ({
  label,
  placeholder,
  name,
  labelProps,
  additionalProps,
  hideValidationMessage,
  interceptor,
  format
}: Props) => {
  return (
    <ThemeWrapper>
      <Field
        parse={v => (interceptor ? interceptor(v) : v)}
        format={v => (format ? format(v) : v)}
        name={name}
        render={p => (
          <FormControl<TextAreaProps>
            {...p}
            component={TextArea}
            hideValidationMessage={hideValidationMessage}
            size="middle"
            placeholder={placeholder}
            label={label}
            labelProps={{
              color: 'darkGray',
              fontSize: '16px',
              fontWeight: 'normal',
              ...labelProps
            }}
            additionalProps={additionalProps}
          />
        )}
      />
    </ThemeWrapper>
  )
}
